import { render, staticRenderFns } from "./GroupsSummary.vue?vue&type=template&id=a9187bcc&scoped=true&"
import script from "./GroupsSummary.vue?vue&type=script&lang=ts&"
export * from "./GroupsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsSummary.vue?vue&type=style&index=0&id=a9187bcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9187bcc",
  null
  
)

export default component.exports